import bowser from 'yola-bowser';

// All modern browser support exif- rotation https://github.com/biigle/annotations/issues/141
// based on exif support table  https://developer.mozilla.org/en-US/docs/Web/CSS/image-orientation

const isExifRotationSupported = () =>
  bowser.isSatisfied({
    desktop: {
      chrome: '>=81',
      firefox: '>=26',
      safari: '>=13.1',
      edge: '>=81',
    },
    tablet: {
      safari: '>=13.1',
      chrome: '>=81',
    },
    mobile: {
      safari: '>=13.1',
      chrome: '>=81',
    },
    iOS: {
      safari: '>=13.1',
      chrome: '>=81',
    },
  });
export default isExifRotationSupported;
